import { Button, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { catchButtonDisplayEvent, catchEditPickupPersonButtonPress, } from '../../../utils/edit-pickup-person/analytics';
import { EditPickupPersonDrawer } from './EditPickupPersonDrawer';
export var EditPickupPerson = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, orderDetailsData = _a.orderDetailsData, orderId = _a.orderId, setPickupPersonState = _a.setPickupPersonState, setPickupPersonFraudError = _a.setPickupPersonFraudError, customerType = _a.customerType;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    useEffect(function () {
        catchButtonDisplayEvent();
    }, []);
    var handleButtonClick = function () {
        setOpen(true);
        catchEditPickupPersonButtonPress();
    };
    return (React.createElement("div", { className: "card-fix" },
        FeatureSwitches.useTrackerAlignedUX ? (React.createElement(Link, { variant: "body-base", onClick: function () { return handleButtonClick(); } }, "Edit")) : (React.createElement(Button, { variant: "secondary", onClick: function () { return handleButtonClick(); } }, "Edit Pickup Person")),
        React.createElement(EditPickupPersonDrawer, { open: open, setOpen: setOpen, fulfillmentGroup: fulfillmentGroup, fulfillmentType: fulfillmentType, orderDetailsData: orderDetailsData, orderId: orderId, setPickupPersonState: setPickupPersonState, setPickupPersonFraudError: setPickupPersonFraudError, customerType: customerType })));
};
